import React, { Fragment, useState, useEffect } from "react";
import { Col, Form, Modal, Row, Image, Button } from "react-bootstrap";
import { OutlinedInput, FormControl, IconButton } from "@material-ui/core";
import { ReusableOnboardingButton } from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ToggleButtonWithYesNo } from "../../../../AllButton/ToggleButtonReuse";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { NewInputText } from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { useFormik } from "formik";
import * as yup from "yup";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { update_item_menu_setup } from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { useHistory } from "react-router-dom";
import Alert from "react-s-alert";
const Services = (props) => {
  const history = useHistory();
  const back = () => {
    props.onChange(8);
    window.scroll(0, 0);
  };
  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    if (props.menuCategoryItems.itemSize === "CUSTOM") {
      formData.currentState = 7;
      formData.runingTrack = 8;
    } else {
      formData.currentState = 6;
      formData.runingTrack = 7;
    }
    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  const onSubmit = () => {};
  const [showDetails, setShowDetails] = useState(false);
  const handleShowDetails = (name) => {
    setActiveName(name);
    if (name === "skip_line") {
      setActiveData(formik.values.skip_line.sizes);
    } else if (name === "take_away") {
      setActiveData(formik.values.take_away.sizes);
    } else if (name === "curb_side") {
      setActiveData(formik.values.curb_side.sizes);
    } else if (name === "dine_in") {
      setActiveData(formik.values.dine_in.sizes);
    }
    setShowDetails(true);
  };
  const handleCloseDetails = () => setShowDetails(false);
  const [showDeleteModal, onShowDeleteModal] = useState(false);
  const handleCloseDeleteModal = () => onShowDeleteModal(false);
  const [activeName, setActiveName] = useState("");
  const [activeData, setActiveData] = useState([]);
  const onClickDeleteSurCharge = (e, id, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    setEditIndex(id);
    onShowDeleteModal(true);
  };
  const handleDeleteModal = (e) => {
    e.preventDefault();

    if (activeNameSurcharge === "skip_line") {
      let updateDeleted = formik.values.skip_line.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("skip_line.sur_charges", updateDeleted);
    } else if (activeNameSurcharge === "take_away") {
      let updateDeleted = formik.values.take_away.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("take_away.sur_charges", updateDeleted);
    } else if (activeNameSurcharge === "curb_side") {
      let updateDeleted = formik.values.curb_side.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("curb_side.sur_charges", updateDeleted);
    } else if (activeNameSurcharge === "dine_in") {
      let updateDeleted = formik.values.dine_in.sur_charges.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("dine_in.sur_charges", updateDeleted);
    }

    onShowDeleteModal(false);
  };

  const [deleteItem, setDeleteItem] = useState(false);
  const closeDeleteItem = () => setDeleteItem(false);

  const onClickDeleteItem = (e, id, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    setEditIndex(id);
    setDeleteItem(true);
  };

  const handleDeleteItem = (e) => {
    e.preventDefault();

    if (activeNameSurcharge === "skip_line") {
      let updateDeleted = formik.values.skip_line.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("skip_line.sizes", updateDeleted);
      setActiveData(updateDeleted);
    } else if (activeNameSurcharge === "take_away") {
      let updateDeleted = formik.values.take_away.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("take_away.sizes", updateDeleted);
      setActiveData(updateDeleted);
    } else if (activeNameSurcharge === "curb_side") {
      let updateDeleted = formik.values.curb_side.sizes.filter(
        (item, index) => {
          return index !== editIndex;
        }
      );
      formik.setFieldValue("curb_side.sizes", updateDeleted);
      setActiveData(updateDeleted);
    } else if (activeNameSurcharge === "dine_in") {
      let updateDeleted = formik.values.dine_in.sizes.filter((item, index) => {
        return index !== editIndex;
      });
      formik.setFieldValue("dine_in.sizes", updateDeleted);
      setActiveData(updateDeleted);
    }
    closeDeleteItem();
  };

  const [active, setActive] = useState(1);
  const handleTextPORV = (e) => {
    setActive(e);
    formikSurcharge.setFieldValue("flag", e);
  };

  const redirectToStep3 = (e) => {
    props.onChange(6);
  };
  const [editIndex, setEditIndex] = useState();
  const [editStatus, setEditStatus] = useState(false);

  const editSurcharge = (e, value, index, name) => {
    e.preventDefault();
    setEditStatus(true);
    setEditIndex(index);
    if (name === "skip_line") {
      setActiveNameSurcharge("skip_line");
      setSkipLineSurCharge(true);
      formikSurcharge.setFieldValue("name", value.name);
      formikSurcharge.setFieldValue("value", value.value);
      formikSurcharge.setFieldValue("flag", value.flag);
    } else if (name === "take_away") {
      setActiveNameSurcharge("take_away");
      setTakeAwaySurCharge(true);
      formikSurcharge.setFieldValue("name", value.name);
      formikSurcharge.setFieldValue("value", value.value);
      formikSurcharge.setFieldValue("flag", value.flag);
    } else if (name === "curb_side") {
      setActiveNameSurcharge("curb_side");
      setCurbSideSurCharge(true);
      formikSurcharge.setFieldValue("name", value.name);
      formikSurcharge.setFieldValue("value", value.value);
      formikSurcharge.setFieldValue("flag", value.flag);
    } else if (name === "dine_in") {
      setActiveNameSurcharge("dine_in");
      setDineInSurcharge(true);
      formikSurcharge.setFieldValue("name", value.name);
      formikSurcharge.setFieldValue("value", value.value);
      formikSurcharge.setFieldValue("flag", value.flag);
    }
  };

  const [activeNameSurcharge, setActiveNameSurcharge] = useState("");
  const [step, setStep] = useState(1);
  const handleStepChange = (v) => setStep(v);

  // skip line start

  const [skipLineSurcharge, setSkipLineSurCharge] = useState(false);
  const onChangeSkipLine = () => {
    formik.setFieldValue("skip_line.value", !formik.values.skip_line.value);
  };

  const onClickAddSkipLineSurcharge = (e) => {
    e.preventDefault();
    setSkipLineSurCharge(!skipLineSurcharge);
  };

  const onClickSaveSkipLineSurcharge = (e, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    formikSurcharge.handleSubmit();
  };

  const onChangeAvaiblity = (status, id, name) => {
    if (name === "skip_line") {
      let updateAvailable = formik.values.skip_line.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue("skip_line.sizes", updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === "take_away") {
      let updateAvailable = formik.values.take_away.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue("take_away.sizes", updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === "curb_side") {
      let updateAvailable = formik.values.curb_side.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue("curb_side.sizes", updateAvailable);
      setActiveData(updateAvailable);
    } else if (name === "dine_in") {
      let updateAvailable = formik.values.dine_in.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, available: !status };
        } else {
          return { ...item };
        }
      });
      formik.setFieldValue("dine_in.sizes", updateAvailable);
      setActiveData(updateAvailable);
    }
  };

  const onChangeDefault = (id, name) => {
    if (name === "skip_line") {
      let defaultStatus = formik.values.skip_line.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue("skip_line.sizes", defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === "take_away") {
      let defaultStatus = formik.values.take_away.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue("take_away.sizes", defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === "curb_side") {
      let defaultStatus = formik.values.curb_side.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue("curb_side.sizes", defaultStatus);
      setActiveData(defaultStatus);
    } else if (name === "dine_in") {
      let defaultStatus = formik.values.dine_in.sizes.map((item, index) => {
        if (index === id) {
          return { ...item, isDefault: true };
        } else {
          return { ...item, isDefault: false };
        }
      });
      formik.setFieldValue("dine_in.sizes", defaultStatus);
      setActiveData(defaultStatus);
    }
  };

  // skip line end

  // take away start
  const [takeAwaySurcharge, setTakeAwaySurCharge] = useState(false);

  const onChangeTakeAway = () => {
    formik.setFieldValue("take_away.value", !formik.values.take_away.value);
  };

  const onClickAddTakeAwaySurcharge = (e) => {
    e.preventDefault();
    setTakeAwaySurCharge(!takeAwaySurcharge);
  };

  const onClickSaveTakeAwaySurcharge = (e, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    formikSurcharge.handleSubmit();
  };

  // take away end

  // curb side start
  const [curbSideSurcharge, setCurbSideSurCharge] = useState(false);

  const onChangeCurbSide = () => {
    formik.setFieldValue("curb_side.value", !formik.values.curb_side.value);
  };

  const onClickAddCurbSideSurcharge = (e) => {
    e.preventDefault();
    setCurbSideSurCharge(!curbSideSurcharge);
  };

  const onClickSaveCurbSideSurcharge = (e, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    formikSurcharge.handleSubmit();
  };

  // curb side end

  // dine in side start
  const [dineInSurcharge, setDineInSurcharge] = useState(false);

  const onChangeDineIn = () => {
    formik.setFieldValue("dine_in.value", !formik.values.dine_in.value);
  };

  const onClickAddDineInSurcharge = (e) => {
    e.preventDefault();
    setDineInSurcharge(!dineInSurcharge);
  };

  const onClickSaveDineInSurcharge = (e, name) => {
    e.preventDefault();
    setActiveNameSurcharge(name);
    formikSurcharge.handleSubmit();
  };
  const onSuccess = () => {
    //props.onChange(7);
    Alert.success(`<h4> Item Added Sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/casual-fine-dining/menusetup");
    window.scroll(0, 0);
  };

  const OnClickNextStep = (e) => {
    e.preventDefault();

    formik.handleSubmit();
  };

  // curb side end

  const formik = useFormik({
    initialValues: {
      skip_line: {
        value: false,
        sizes: [],
        sur_charges: [],
      },
      take_away: {
        value: false,
        sizes: [],
        sur_charges: [],
      },
      curb_side: {
        value: false,
        sizes: [],
        sur_charges: [],
      },
      dine_in: {
        value: false,
        sizes: [],
        sur_charges: [],
      },
    },
    //validate,

    onSubmit: (values) => {
      // props.onChange(7);
      // window.scroll(0, 0);
      let formData = {};
      formData = { ...formik.values };
      const token = props.auth.user.accessToken;
      formData.currentState = 9;
      formData.runingTrack = 9;
      props.update_item_menu_setup(
        props.activeItemId,
        formData,
        token,
        onSuccess
      );
    },
  });

  const formikSurcharge = useFormik({
    initialValues: {
      name: "",
      value: "",
      flag: "PERCENTAGE",
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, "Must be 128 characters or less")
        .required("Surcharge name  is required"),
      value: yup.number().required("This field is required"),
    }),
    onSubmit: (values) => {
      if (activeNameSurcharge === "skip_line" && !editStatus) {
        let oldSurcharges = formik.values.skip_line.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue("skip_line.sur_charges", oldSurcharges);
        setSkipLineSurCharge(false);
      } else if (activeNameSurcharge === "skip_line" && editStatus) {
        let oldSurcharges = formik.values.skip_line.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`skip_line.sur_charges`, oldSurcharges);
        setEditIndex("");
        setEditStatus(false);
        setSkipLineSurCharge(false);
      } else if (activeNameSurcharge === "take_away" && !editStatus) {
        let oldSurcharges = formik.values.take_away.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue("take_away.sur_charges", oldSurcharges);
        setTakeAwaySurCharge(false);
      } else if (activeNameSurcharge === "take_away" && editStatus) {
        let oldSurcharges = formik.values.take_away.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`take_away.sur_charges`, oldSurcharges);
        setEditIndex("");
        setEditStatus(false);
        setTakeAwaySurCharge(false);
      } else if (activeNameSurcharge === "curb_side" && !editStatus) {
        let oldSurcharges = formik.values.curb_side.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue("curb_side.sur_charges", oldSurcharges);
        setCurbSideSurCharge(false);
      } else if (activeNameSurcharge === "curb_side" && editStatus) {
        let oldSurcharges = formik.values.take_away.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`curb_side.sur_charges`, oldSurcharges);
        setEditIndex("");
        setEditStatus(false);
        setCurbSideSurCharge(false);
      } else if (activeNameSurcharge === "dine_in" && !editStatus) {
        let oldSurcharges = formik.values.dine_in.sur_charges;
        oldSurcharges.push(values);
        formik.setFieldValue("dine_in.sur_charges", oldSurcharges);
        setDineInSurcharge(false);
      } else if (activeNameSurcharge === "dine_in" && editStatus) {
        let oldSurcharges = formik.values.dine_in.sur_charges;
        oldSurcharges[editIndex] = values;
        formik.setFieldValue(`dine_in.sur_charges`, oldSurcharges);
        setEditIndex("");
        setEditStatus(false);
        setDineInSurcharge(false);
      }
      formikSurcharge.resetForm();
    },
  });

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;

      if (data.itemSize === "SINGLE") {
        data.size[0].description = data.name;
        data.size[0].isDefault = true;
        data.size[0].available = true;
      }
      if (data.currentState === 9) {
        formik.setFieldValue("skip_line", data.skip_line);
        formik.setFieldValue("take_away", data.take_away);
        formik.setFieldValue("curb_side", data.curb_side);
        formik.setFieldValue("dine_in", data.dine_in);
      } else {
        formik.setFieldValue("skip_line.sizes", data.size);
        formik.setFieldValue("take_away.sizes", data.size);
        formik.setFieldValue("curb_side.sizes", data.size);
        formik.setFieldValue("dine_in.sizes", data.size);
      }
    }
  }, [props.menuCategoryItems]);
  return (
    <React.Fragment>
      <Form>
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl
                  className={"w-100 bg-white md-p-9"}
                  variant="outlined"
                >
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        {step === 1 && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-01.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Skip The Line
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.skip_line.value}
                  onChange={() => onChangeSkipLine()}
                />
              </div>
            </div>
            <>
              {formik.values.skip_line.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.skip_line.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("skip_line")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  <>
                    {formik.values.skip_line.sizes.map((item, index) => (
                      <Fragment key={index}>
                        <Row className="align-items-center">
                          <Col md={2} className="pb-2">
                            <Form.Check
                              label="1"
                              inline
                              className="enCheckBoxOnly d-grid"
                              checked={item.available}
                              onChange={(e) =>
                                onChangeAvaiblity(
                                  item.available,
                                  index,
                                  "skip_line"
                                )
                              }
                            />
                          </Col>
                          <Col md={2} className="pb-2">
                            <label className="enRadioWithText small d-grid">
                              <input
                                type="radio"
                                name="setDefaultSkipLine"
                                checked={item.isDefault}
                                onChange={(e) =>
                                  onChangeDefault(index, "skip_line")
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </Col>
                          <Col md={4} className="pb-2">
                            <div className="f11-400">{item.description}</div>
                          </Col>
                          <Col md={4} className="pb-2">
                            <div className="d-flex align-itmes-center">
                              <IconButton className="mr-2 p-0">
                                <Image
                                  src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                  alt="add"
                                  title="add"
                                  className="w-20px"
                                />
                              </IconButton>
                              <IconButton className="p-0">
                                <Image
                                  src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                  alt="add"
                                  title="add"
                                  className="w-20px"
                                  onClick={(e) =>
                                    onClickDeleteItem(e, index, "skip_line")
                                  }
                                />
                              </IconButton>
                            </div>
                          </Col>
                        </Row>
                        <hr />
                      </Fragment>
                    ))}
                  </>
                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.skip_line.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "skip_line")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "skip_line")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText={`Add Surcharge`}
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddSkipLineSurcharge(e)}
                    />
                  </div>

                  <>
                    {skipLineSurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />

                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveSkipLineSurcharge(e, "skip_line")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddSkipLineSurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => onClickBack()}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStepChange(2)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 2 && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-02.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Take Away
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.take_away.value}
                  onChange={() => onChangeTakeAway()}
                />
              </div>
            </div>
            <>
              {formik.values.take_away.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.take_away.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("take_away")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.take_away.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "take_away"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefaultTakeAway"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "take_away")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "take_away")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}
                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.take_away.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "take_away")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "take_away")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddTakeAwaySurcharge(e)}
                    />
                  </div>
                  <>
                    {takeAwaySurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />

                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveTakeAwaySurcharge(e, "take_away")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddTakeAwaySurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(1)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStepChange(3)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 3 && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-03.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Curb Side
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.curb_side.value}
                  onChange={() => onChangeCurbSide()}
                />
              </div>
            </div>
            <>
              {formik.values.curb_side.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.curb_side.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("curb_side")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.curb_side.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "curb_side"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefaultCurbSide"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "curb_side")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "curb_side")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}
                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.curb_side.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "curb_side")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "curb_side")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddCurbSideSurcharge(e)}
                    />
                  </div>
                  <>
                    {curbSideSurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />

                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveCurbSideSurcharge(e, "curb_side")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddCurbSideSurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(2)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStepChange(4)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 4 && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-03.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Dine In
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.dine_in.value}
                  onChange={() => onChangeDineIn()}
                />
              </div>
            </div>
            <>
              {formik.values.dine_in.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.dine_in.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("dine_in")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.dine_in.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "dine_in"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefaultDineIn"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "dine_in")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "dine_in")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}
                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.dine_in.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "dine_in")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "dine_in")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddDineInSurcharge(e)}
                    />
                  </div>
                  <>
                    {dineInSurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />

                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveDineInSurcharge(e, "dine_in")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddDineInSurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(3)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Next"
                buttonType="button"
                onClick={() => handleStepChange(5)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 5 && (
          <React.Fragment>
            <div className="f14-700">Available for Services</div>
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-01.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Skip The Line
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.skip_line.value}
                  onChange={() => onChangeSkipLine()}
                />
              </div>
            </div>
            <>
              {formik.values.skip_line.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.skip_line.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("skip_line")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}

                  {formik.values.skip_line.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "skip_line"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefault"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "skip_line")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "skip_line")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}

                  <div className="f12-700 mb-2">Surcharge:</div>
                  {formik.values.skip_line.sur_charges.map((item, index) => (
                    <Row className="align-items-center" key={index}>
                      <Col md={4} className="mb-2">
                        <div className="f11-400">{item.name}</div>
                      </Col>
                      <Col md={2} className="mb-2">
                        <div className="f11-400">
                          {item.value} {item.flag === "PERCENTAGE" ? "%" : "₹"}
                        </div>
                      </Col>
                      <Col md={3} className="mb-2">
                        <div className="d-flex align-itmes-center">
                          <IconButton className="mr-2 p-0">
                            <Image
                              src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                              alt="add"
                              title="add"
                              className="w-20px"
                              onClick={(e) =>
                                editSurcharge(e, item, index, "skip_line")
                              }
                            />
                          </IconButton>
                          <IconButton className="p-0">
                            <Image
                              src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                              alt="add"
                              title="add"
                              className="w-20px"
                              onClick={(e) =>
                                onClickDeleteSurCharge(e, index, "skip_line")
                              }
                            />
                          </IconButton>
                        </div>
                      </Col>
                    </Row>
                  ))}
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddSkipLineSurcharge(e)}
                    />
                  </div>
                  <>
                    {skipLineSurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />
                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveSkipLineSurcharge(e, "skip_line")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddSkipLineSurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <hr />
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-02.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Take Away
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.take_away.value}
                  onChange={() => onChangeTakeAway()}
                />
              </div>
            </div>
            <>
              {formik.values.take_away.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.take_away.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("take_away")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}
                  {formik.values.take_away.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "take_away"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefault"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "take_away")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "take_away")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}

                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.take_away.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "take_away")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "take_away")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddTakeAwaySurcharge(e)}
                    />
                  </div>
                  <>
                    {takeAwaySurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />

                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveTakeAwaySurcharge(e, "take_away")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddTakeAwaySurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <hr />
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-03.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Curb Side
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.curb_side.value}
                  onChange={() => onChangeCurbSide()}
                />
              </div>
            </div>
            <>
              {formik.values.curb_side.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.curb_side.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("curb_side")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}
                  {formik.values.curb_side.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "curb_side"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefault"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "curb_side")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "curb_side")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}
                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.curb_side.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "curb_side")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "curb_side")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddCurbSideSurcharge(e)}
                    />
                  </div>
                  <>
                    {curbSideSurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />
                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveCurbSideSurcharge(e, "curb_side")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddCurbSideSurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <hr />
            <div className="d-flex align-items-center justify-content-between pt-3 pb-4">
              <div className="f14-700 col-8 col-md-8 col-lg-6 p-0 d-flex align-items-center">
                <div className="enIconShadow mr-3">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/Icons-03.svg")}
                    alt="add"
                    className="w-20px"
                  />
                </div>
                Dine In
              </div>
              <div className="col-4 col-md-4 col-lg-6">
                <ToggleButtonWithYesNo
                  checkedBox={formik.values.dine_in.value}
                  onChange={() => onChangeDineIn()}
                />
              </div>
            </div>
            <>
              {formik.values.dine_in.value ? (
                <>
                  <div className="d-flex flex-wrap align-items-center justify-content-between pb-3">
                    <div className="f12-700">Set Availability and Price :</div>
                    <button
                      type="button"
                      className={
                        "add-button-icon-reusable add-button-icon-reusable-blue"
                      }
                      // onClick={handleShowDetails}
                      onClick={(e) => redirectToStep3(e)}
                    >
                      Missing a Size ? Add
                    </button>
                  </div>
                  {formik.values.dine_in.sizes.length !== 0 ? (
                    <Row>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Available</div>
                      </Col>
                      <Col md={2} className="pb-4">
                        <div className="f11-700">Set Default</div>
                      </Col>
                      <Col md={4} className="pb-4">
                        <div className="f11-700">Add Size Description</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <div className="f11-700">Action</div>
                      </Col>
                      <Col md={2} className="pb-3">
                        <button
                          type="button"
                          className={
                            "add-button-icon-reusable add-button-icon-reusable-blue"
                          }
                          onClick={() => handleShowDetails("dine_in")}
                        >
                          See more
                        </button>
                      </Col>
                    </Row>
                  ) : (
                    <> </>
                  )}
                  {formik.values.dine_in.sizes.map((item, index) => (
                    <Fragment key={index}>
                      <Row className="align-items-center">
                        <Col md={2} className="pb-2">
                          <Form.Check
                            label="1"
                            inline
                            className="enCheckBoxOnly d-grid"
                            checked={item.available}
                            onChange={(e) =>
                              onChangeAvaiblity(
                                item.available,
                                index,
                                "dine_in"
                              )
                            }
                          />
                        </Col>
                        <Col md={2} className="pb-2">
                          <label className="enRadioWithText small d-grid">
                            <input
                              type="radio"
                              name="setDefault"
                              checked={item.isDefault}
                              onChange={(e) =>
                                onChangeDefault(index, "dine_in")
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="f11-400">{item.description}</div>
                        </Col>
                        <Col md={4} className="pb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteItem(e, index, "dine_in")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                      <hr />
                    </Fragment>
                  ))}
                  <>
                    <div className="f12-700 mb-2">Surcharge:</div>
                    {formik.values.dine_in.sur_charges.map((item, index) => (
                      <Row className="align-items-center" key={index}>
                        <Col md={4} className="mb-2">
                          <div className="f11-400">{item.name}</div>
                        </Col>
                        <Col md={2} className="mb-2">
                          <div className="f11-400">
                            {item.value}{" "}
                            {item.flag === "PERCENTAGE" ? "%" : "₹"}
                          </div>
                        </Col>
                        <Col md={3} className="mb-2">
                          <div className="d-flex align-itmes-center">
                            <IconButton className="mr-2 p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  editSurcharge(e, item, index, "dine_in")
                                }
                              />
                            </IconButton>
                            <IconButton className="p-0">
                              <Image
                                src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                                alt="add"
                                title="add"
                                className="w-20px"
                                onClick={(e) =>
                                  onClickDeleteSurCharge(e, index, "dine_in")
                                }
                              />
                            </IconButton>
                          </div>
                        </Col>
                      </Row>
                    ))}
                  </>
                  <div className="py-3">
                    <AddButtonIconComponent
                      buttonText="Add Surcharge"
                      fontIcon="fa fa-plus"
                      colorCss="blue"
                      buttonType="button"
                      onClick={(e) => onClickAddDineInSurcharge(e)}
                    />
                  </div>
                  <>
                    {dineInSurcharge ? (
                      <Row>
                        <Col md={5} xl={5}>
                          <NewInputText
                            labelText="Surcharge Name"
                            extraClass={`mb-2 w-100 ${
                              formikSurcharge.errors.name &&
                              formikSurcharge.touched.name
                                ? "enError"
                                : ""
                            }`}
                            name="name"
                            onChange={formikSurcharge.handleChange}
                            value={formikSurcharge.values.name}
                            onFocusOut={formikSurcharge.handleBlur}
                          />
                          {formikSurcharge.errors.name &&
                          formikSurcharge.touched.name ? (
                            <div className="pho_14_regular text-danger">
                              {formikSurcharge.errors.name}
                            </div>
                          ) : null}
                        </Col>
                        <Col md={4} xl={4}>
                          <div className="w-100">
                            <div
                              className={`enFiledWith2Btn mt-0 mb-2  ${
                                formikSurcharge.errors.value &&
                                formikSurcharge.touched.value
                                  ? "enError"
                                  : ""
                              }`}
                            >
                              <input
                                type="number"
                                placeholder="% or Value"
                                // className={`f12-400  ${
                                //   formikSurcharge.errors.value &&
                                //   formikSurcharge.touched.value
                                //     ? "enError"
                                //     : ""
                                // }`}
                                className="f12-400"
                                name="value"
                                onChange={formikSurcharge.handleChange}
                                value={formikSurcharge.values.value}
                                onFocusOut={formikSurcharge.handleBlur}
                              />
                              <div className="btnGroup">
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("PERCENTAGE")}
                                  className={`${
                                    formikSurcharge.values.flag === "PERCENTAGE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  %
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleTextPORV("VALUE")}
                                  className={`${
                                    formikSurcharge.values.flag === "VALUE"
                                      ? "active"
                                      : ""
                                  }`}
                                >
                                  ₹
                                </button>
                              </div>
                            </div>
                            {formikSurcharge.errors.value &&
                            formikSurcharge.touched.value ? (
                              <div className="pho_14_regular text-danger">
                                {formikSurcharge.errors.value}
                              </div>
                            ) : null}
                          </div>
                        </Col>
                        <Col md={3} xl={3}>
                          <div className="d-flex align-itmes-center pt-2">
                            <Button
                              variant="link"
                              className="f11-500 mr-2 text-red "
                              onClick={(e) =>
                                onClickSaveDineInSurcharge(e, "dine_in")
                              }
                            >
                              Save
                            </Button>
                            <Button
                              variant="link"
                              className="f11-500 text-dark "
                              onClick={(e) => onClickAddDineInSurcharge(e)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <> </>
                    )}
                  </>
                </>
              ) : (
                <> </>
              )}
            </>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(4)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Finish"
                buttonType="button"
                // onClick={onSubmit}
                onClick={(e) => OnClickNextStep(e)}
              />
            </div>
          </React.Fragment>
        )}
      </Form>
      <Modal show={showDetails} onHide={handleCloseDetails} centered size="xl">
        <Modal.Header className="px-4 border-0" closeButton>
          <Modal.Title className="f20-700">Saved Size Description</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="enGrayBorderBox mb-3">
            <div className="table-responsive">
              <table className="enMinWidth900 w-100 table m-0">
                <tr>
                  <td>
                    <div className="f11-400  pb-2">Available</div>
                  </td>
                  <td>
                    <div className="f11-400  pb-2">Set Default</div>
                  </td>
                  <td>
                    <div className="f11-400  pb-2">Size Description</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Item Price</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Serving PAX</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Units</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Measure</div>
                  </td>
                  <td>
                    <div className="f11-400 pb-2">Action</div>
                  </td>
                </tr>
                {activeData.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <Form.Check
                        label="1"
                        inline
                        className="enCheckBoxOnly d-grid"
                        checked={item.available}
                        onChange={(e) =>
                          onChangeAvaiblity(item.available, index, activeName)
                        }
                      />
                    </td>
                    <td>
                      <label className="enRadioWithText small d-grid">
                        <input
                          type="radio"
                          name="setDefault"
                          checked={item.isDefault}
                          onChange={(e) => onChangeDefault(index, activeName)}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>
                      <div className="f12-700">{item.description}</div>
                    </td>
                    <td>
                      <input
                        type="text"
                        value={item.price}
                        className="enPriceInput"
                      />
                    </td>
                    <td>
                      <div className="f12-700">{item.pax}</div>
                    </td>
                    <td>
                      <div className="f12-700">{item.size}</div>
                    </td>
                    <td>
                      <div className="f12-700">{item.uom}</div>
                    </td>
                    <td>
                      <div className="d-flex align-itmes-center mt-2">
                        <IconButton className="mr-2 p-0">
                          <Image
                            src={require("../../../../../../../../assets/images/UserManagement/editBlue.svg")}
                            alt="edit image"
                            title="edit"
                            className="w-20px"
                            //onClick={(e) => onEditItem(index, item)}
                          />
                        </IconButton>
                        <IconButton className="p-0">
                          <Image
                            src={require("../../../../../../../../assets/images/UserManagement/delete-gray.svg")}
                            alt="delete image"
                            title="delete item"
                            className="w-20px"
                            // onClick={(e) => onClickDeleteIcon(e, index)}
                            onClick={(e) =>
                              onClickDeleteItem(e, index, activeName)
                            }
                          />
                        </IconButton>
                      </div>
                    </td>
                  </tr>
                ))}
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete this surcharge ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteModal}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => handleDeleteModal(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={deleteItem} onHide={closeDeleteItem} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to delete this item ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={closeDeleteItem}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={(e) => handleDeleteItem(e)}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

Services.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,

  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
});

export default connect(mapStateToProps, { update_item_menu_setup })(Services);
